import {
	Button, Empty, Pagination, Table
}from "antd"
import React, {
	useEffect, useState
}from "react"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	appealsCollectiveActions
}from "./store/actions"
import "antd/lib/table/style/index.css"
// test
// import "antd/lib/pagination/style/index.css"
import '../../../pagination.css'
import {
	Link
}from "react-router-dom"
import './style.css'
import CustomButton from "../../../components/ButtonCustom"
import i18n from "../localization"

const CollectiveAppealList = (props) => {
	const dispatch = useDispatch()
	const { CollectiveAppeals, CollectiveAppealsSending } = useSelector((state) => state.collectiveAppealReducer)
	const isRu = useSelector(state => state.globalReducer.isRu)
	const [data, setData] = useState(null)
	const [page, setPage] = useState(1)
	const columns = [
		{
			title     : '№',
			dataIndex : 'index',
			key       : 'index'
		},
		{
			title     : `${i18n.collectiveAppealsListId[isRu]}`,
			dataIndex : 'regNumber',
			key       : 'regNumber'
		},
		{
			title     : `${i18n.themeOgul[isRu]}`,
			dataIndex : 'themeOgul',
			key       : 'themeOgul'
		},
		{
			title     : `${i18n.subThemeOgul[isRu]}`,
			dataIndex : 'subthemeOgul',
			key       : 'subthemeOgul'
		},
		{
			title     : `${i18n.appealType[isRu]}`,
			dataIndex : 'isPrivate',
			key       : 'subthemeOgul'
		},
		{
			title     : '',
			dataIndex : 'action',
			key       : 'action',
			render    : (id) => (<Link to={ `/collectiveAppeal/${ id }` }>
				<CustomButton type="orange">
				{ i18n.SubmitedAppealManage[isRu] }
				</CustomButton>
			</Link>)
		}

	]

	useEffect(() => {
		dispatch(appealsCollectiveActions.GetCollectiveAppeals({
			Page     : 0,
			PageSize : 10
		}))
		return () => {
			dispatch(appealsCollectiveActions.ClearGetCollectiveAppeals())
		}
	}, [])

	useEffect(() => {
		if (CollectiveAppeals){
			const data = []
			CollectiveAppeals.items.forEach((ca, index) => {
				data.push({
					key          : index + 1,
					index        : index + 1,
					regNumber    : ca.regNumber,
					themeOgul    : isRu ? ca.themeOgul : ca.themeOgulBel,
					subthemeOgul : isRu ? ca.subthemeOgul : ca.subthemeOgulBel,
					action       : ca.id,
					isPrivate    : ca.isPrivate ? `${i18n.closeCollectAppeal[isRu]}`:`${i18n.openCollectAppeal[isRu]}`
				})
			})
			setData(data)
		}
	}, [CollectiveAppeals, isRu])

	function onPaginationChange(value){
		setPage(value)
		dispatch(appealsCollectiveActions.GetCollectiveAppeals({
			Page     : value - 1,
			PageSize : 10
		}))
	}

	return (
		<>
			{ data ?
				(<div
					className="collective-appeals"
					style={ { marginBottom: "3%" } }
				>
					<Table
						columns={ columns }
						dataSource={ data }
						pagination={ false }
						scroll={ { x: 1300 } }
					/>
					{ CollectiveAppeals.pageCount > 1 ?
						(<Pagination
							current={ page }
							defaultCurrent={ 1 }
							pageSize={ 10 }
							showSizeChanger={ false }
							style={ { marginTop    : '1%',
								marginBottom : "3%" } }
							total={ CollectiveAppeals.count }
							onChange={ onPaginationChange }
						/>)
						: null }
				</div>)
				: <Empty /> }
		</>
	)
}

export default CollectiveAppealList
